import { getEnv } from "../../../data/env";

const basePath = getEnv('REACT_APP_IMG_URL');

export default function Img(props) {
    return (
        <img {...props} src={`${basePath}/${props.src}`} alt="" />
    );
}
